import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Rocket } from 'lucide-react';

export default function CTA() {
  return (
    <section className="relative max-w-7xl mx-auto px-5 md:px-8 py-16">
      <div className="reveal relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#0f172a] to-[#0b132b] p-10 md:p-16 text-center">
        <div className="absolute inset-0 animate-sheen bg-[linear-gradient(110deg,transparent,rgba(37,99,235,0.12),transparent)]" aria-hidden />
        <div className="absolute inset-0" aria-hidden>
          <div className="absolute w-[380px] h-[380px] rounded-full bg-[#2563eb]/25 blur-[100px] -top-24 -left-10" />
          <div className="absolute w-[320px] h-[320px] rounded-full bg-[#4f46e5]/20 blur-[100px] -bottom-24 -right-10" />
        </div>
        <div className="relative">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/15 px-4 py-1.5 text-xs font-medium text-slate-200 mb-6">
            <Rocket size={14} className="text-blue-400" /> Ready when you are
          </span>
          <h2 className="font-display text-3xl md:text-5xl font-bold text-white max-w-2xl mx-auto leading-tight">
            Ready to Scale Your <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-400">Growth?</span>
          </h2>
          <p className="mt-4 text-slate-300 max-w-xl mx-auto">
            Let's build a performance strategy around your goals, markets and KPIs.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <Link data-testid="cta-primary-button" to="/contact" className="group inline-flex items-center gap-2 rounded-full bg-blue-600 px-8 py-4 font-semibold text-white hover:bg-blue-500 transition-colors shadow-lg shadow-blue-600/30">
              Talk to Our Team <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </Link>
            <Link data-testid="cta-secondary-button" to="/contact" className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/5 px-8 py-4 font-semibold text-white hover:bg-white/10 transition-colors">
              Start a Campaign
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
